import React from "react";
import ClientShiftsHeader from "./ClientShiftsHeader";
import ClientShiftsSubNav from "./ClientShiftsSubNav";

export default function ClientShiftsPageShell({
  children,
  bodyClassName = "",
}) {
  return (
    <div className="flex-1 flex flex-col min-w-0 min-h-0 overflow-hidden bg-background">
      <ClientShiftsHeader />
      <div
        className={`flex-1 min-h-0 overflow-hidden flex flex-col px-6 pt-3 pb-2 ${bodyClassName}`}
      >
        <div className="flex-shrink-0">
          <ClientShiftsSubNav />
        </div>
        {children}
      </div>
    </div>
  );
}
